import { useMemo } from 'react'
import { useServices } from './useServices'

const shuffle = (items) => {
  const result = [...items]
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }
  return result
}

export const useRandomWorks = (count) => {
  const { data: apiServices = [], isLoading } = useServices()

  const items = useMemo(() => {
    const pool = apiServices.flatMap((service) =>
      (service.beforeAfter || []).map((pair, index) => ({
        id: `${service.slug}-${index}`,
        beforeSrc: pair.beforeImage,
        afterSrc: pair.afterImage,
        altBefore: `До — ${service.title}`,
        altAfter: `После — ${service.title}`,
        serviceTitle: service.title,
      }))
    )
    return shuffle(pool).slice(0, count)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiServices, count])

  return { items, isLoading }
}

export default useRandomWorks
